import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import _ from "lodash";
import { Box, Grid2, Stack, Typography, useTheme } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import { EGInput } from "../../../../../MainComponents/Input/EGInput";
import { returnIsValid } from "../../Main/useConstants";
import { DragAndDropFiles, InvestigationButton, ModalContainer, TemporalUploadedFile } from "../../components"

const validateForm = (file, details) => {
  const errors = {};

  if (!file) errors.files = true;
  if (!details) errors.details = true;

  return [
    Object.entries(errors).length === 0 ? true : false,
    errors
  ];
};

export const AddFile = ({
  show,
  onHide,
  files,
  setFiles,
}) => { 

  const theme = useTheme();
  const [t] = useTranslation("investigation");

  const [newFiles, setNewFiles] = useState([]);
  const [details, setDetails] = useState("");
  
  const [errors, setErrors] = useState({});
  const [triedToSave, setTriedToSave] = useState(false);

  useEffect(() => {
    if (!show) {
      resetValues();
    }
  }, [show]);

  // Validar en cada cambio
  useEffect(() => {
    if (triedToSave) {
      const [_, errors] = validateForm(newFiles, details);
      setErrors(errors);
    }
  }, [newFiles, details]);

  const handleChangeFiles = (eventFiles) => {
    setNewFiles([ ...newFiles, ...eventFiles ]);
  }

  const handleRemoveFile = (idx) => {
    setNewFiles(newFiles.filter((_, i) => i !== idx));
  }

  const handleClose = () => {
    resetValues();
    onHide();
  }

  const handleSave = async() => {
    setTriedToSave(true);
    const [isValid, errors] = validateForm(newFiles, details);
    setErrors(errors);
    setTriedToSave(true);
    if (!isValid) {
      enqueueSnackbar({ variant: "error", message: t("resources.missing_required_inputs") });
      return;
    };

    const filesWithDetails = _.cloneDeep(newFiles);
    newFiles.forEach((_, idx) => {
      newFiles[idx].details = details;
    });
    setFiles([...files, ...filesWithDetails]);
    handleClose();
  }

  const resetValues = () => {
    setDetails("");
    setNewFiles([]);
    setErrors({});
    setTriedToSave(false);
  }

  return (
    <ModalContainer show={show} onHide={onHide}>
      <Stack spacing={2}>
        
        {/* Header */}
        <Box>
          <Typography fontWeight={700} fontSize={28} color={theme.palette.ethicsBlue.main}>
            {t("Conclusion.upload_files_modal_title")}
          </Typography>
          <Typography fontSize={16} color="oxfordBlue" >
            {t("Conclusion.upload_files_modal_description")}
          </Typography>

          <hr style={{ marginBottom: 0 }} />
        </Box>

        <DragAndDropFiles
          text={t("Conclusion.upload_files_modal_btn_drag_and_drop")}
          multiple
          onFileSelect={handleChangeFiles}
          isValid={returnIsValid(errors?.files, triedToSave) ?? null}
        />

        <Grid2 container spacing={2} justifyContent="flex-start" alignItems="center">
          {
            newFiles.map((file, idx) => (
              <Grid2 key={idx} size={{ xs: 12, md: 6 }}>
                <TemporalUploadedFile
                  name={file?.name}
                  size={file?.size}
                  iconName={`${file != null ? "trash_can" : ""}`}
                  iconColor={theme.palette.red.main}
                  iconAction={() => handleRemoveFile(idx)}
                  width="100%"
                />
              </Grid2>
            ))
          }
        </Grid2>

        <EGInput
          label={t("Conclusion.explains_briefly")}
          value={details}
          onChange={(e) => setDetails(e.target.value)}
          multiline
          rows={3}
          required
          isValid={returnIsValid(errors?.details, triedToSave) ?? null}
          showSuccessValidation
          showHelpText={false}
        />

        {/* Botones */}
        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <InvestigationButton
            label={t("Conclusion.cancel")}
            variant="main"
            outlined
            onClick={handleClose}
          />
          <InvestigationButton
            label={t("Conclusion.save")}
            variant="main"
            onClick={handleSave}
          />
        </Stack>
      </Stack>
    </ModalContainer>
  )
}
